import './_style.less';
import { Modal, Divider } from 'antd';

interface SessionDetail {
  session: number;
  formattedDate: string;
  rawDate: string;
  timeLabel: string;
  label: string;
}

interface ModalScheduleDetailsProps {
  visible: boolean;
  onCancel: () => void;
  sessionDetails: SessionDetail[];
}

const ModalScheduleDetails: React.FC<ModalScheduleDetailsProps> = ({
  visible,
  onCancel,
  sessionDetails
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title={<span className="modal-title">Schedule Details</span>}
      centered
      width={420}
      bodyStyle={{ padding: 24 }}
      closeIcon={<span className="modal-close-icon">&times;</span>}
      className="modal-schedule-details"
    >
      <div className="session-list">
        {sessionDetails.map((item, idx) => (
          <div key={idx} className="session-item">
            <div className="session-title">
              Session {item.session}
            </div>
            <div className="session-details">
              {item.formattedDate}
              {item.timeLabel ? ` | ${item.timeLabel} (GMT +7)` : ''}
            </div>
            {idx < sessionDetails.length - 1 && <Divider className="session-divider" />}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ModalScheduleDetails;
